export enum TransactionTypeEnum {
  COMPRA = 1,
  CRIACAO_CONTA = 2,
  ANIVERSARIO = 7,
  INSCRICAO_NEWSLETTER = 3,
  REVIEW_PRODUTO = 8,
  INDICACAO = 9,
  MANUAL = 10,
  SEGUIR_TWITTER = 6,
  SEGUIR_INSTAGRAM = 5,
  CURTIR_FACEBOOK = 4,
}

export const TransactionTypeMap = new Map<TransactionTypeEnum, string>();
TransactionTypeMap.set(TransactionTypeEnum.COMPRA, 'Compra');
TransactionTypeMap.set(TransactionTypeEnum.CRIACAO_CONTA, 'Criação de Conta');
TransactionTypeMap.set(TransactionTypeEnum.ANIVERSARIO, 'Aniversário');
TransactionTypeMap.set(TransactionTypeEnum.INSCRICAO_NEWSLETTER, 'Inscrição na Newsletter');
TransactionTypeMap.set(TransactionTypeEnum.REVIEW_PRODUTO, 'Review de Produto');
TransactionTypeMap.set(TransactionTypeEnum.INDICACAO, 'Indicação');
TransactionTypeMap.set(TransactionTypeEnum.MANUAL, 'Manual');
TransactionTypeMap.set(TransactionTypeEnum.SEGUIR_TWITTER, 'Seguir Twitter');
TransactionTypeMap.set(TransactionTypeEnum.SEGUIR_INSTAGRAM, 'Seguir Instagram');
TransactionTypeMap.set(TransactionTypeEnum.CURTIR_FACEBOOK, 'Curtir Facebook');










